import React, { useState, createContext,useContext,useEffect,useReducer } from "react";

const data = {
  username: '', 
  nombreCompleto:'',
  emailAddress: '',
  netId: '',
  idinv: 0,
  idunidad: 0,
  unidad: '',
  nombres: '',
  apellidos: '',
  tipoidentificacion: '',
  numeroidentificacion: '',
  codestudiante: '',
  idpersona: 0,
  roles: [],
  foto: '',
  token: '',
  autorizado: 0,
  crearproyecto:0,
  orcid: '',
  hindex: '',
  scholarid: '',
  scopusid:''
};
const initialState = {
  // Define tu estado inicial aquí
};
// Create Context Object
export const CasUserContext = createContext();

export const useCasUserContext = () => {
  //return useContext(CasUserContext);
  const context = useContext(CasUserContext);
  if (!context) {
    throw new Error('useCasUserContext debe ser utilizado dentro de un CasUserContextProvider');
  }
  return context;
};

const reducer = (state, action) => {
  switch (action.type) {
    // Define tus casos de acción aquí
    default:
      return state;
  }
};

// Create a provider for components to consume and subscribe to changes
export const CasUserContextProvider = (props) => {
  const [user,setUser] = useState(false);
  const [token,setToken] = useState('');
  const [userData,setUserData] = useState(data);
  const [checking,setChecking] = useState(false);
  const [state, dispatch] = useReducer(reducer, initialState);
  //console.log(userData);
  //console.log(token);
  
  function checkAndRestoreSessionData() {
    const storedToken = sessionStorage.getItem('token');
    const storedUserData = sessionStorage.getItem('userData');

    if (!storedToken || !storedUserData) {
      // Al menos uno de los datos está vacío, restaura desde el estado inicial o realiza alguna acción
      // Por ejemplo, puedes redirigir al usuario a una página de inicio de sesión
      // O cargar datos iniciales desde otro lugar
      //console.log('No hay cambios');
    } else {
      // Ambos datos están disponibles, restaura el estado
      //console.log(token);
      setToken(storedToken);
      //console.log(storedToken);
      setUserData(JSON.parse(storedUserData));
      //console.log(storedUserData);
    }
  };

  // Cargar datos de sessionStorage al iniciar
  useEffect(() => {
    const storedToken = sessionStorage.getItem('token');
    if (storedToken) {
      setToken(storedToken);
    }

    const storedUserData = sessionStorage.getItem('userData');
    if (storedUserData) {
      setUserData(JSON.parse(storedUserData));
    }
  }, []);

  // Guardar datos en sessionStorage cuando cambian
  useEffect(() => {
    sessionStorage.setItem('token', token);
  }, [token]);

  useEffect(() => {
    sessionStorage.setItem('userData', JSON.stringify(userData));
  }, [userData]);

  return (
    <CasUserContext.Provider value={{ user, setUser,token,setToken,userData,setUserData,checking,setChecking }}>
      {props.children}
    </CasUserContext.Provider>
  );
};
